import { Language } from "../../../constants/language";
import { CONTACT_EN } from "../../../models/contact/contact";
import { Book, BookCategory, BookFormat } from "../../../models/product/book";
import { ProductType } from "../../../models/product/product";
import { MIRA_MAKRAM_AR, MIRA_MAKRAM_EN, SARAH_ESSAM_AR, SARAH_ESSAM_EN, TONY_MODY_AR, TONY_MODY_EN } from "../../translators/translators-data";
import { AUTHOR_NAMES_AR, AUTHOR_NAMES_EN } from "../author/author-names";
import { DISCERNMENT_OF_SPIRITS_MEDIA_AR, DISCERNMENT_OF_SPIRITS_MEDIA_EN, FACE_TO_FACE_MEDIA_AR, FACE_TO_FACE_MEDIA_EN, LETTERS_OF_FIRE_MEDIA_AR, LETTERS_OF_FIRE_MEDIA_EN, POSSESSING_THE_GATES_OF_THE_ENEMY_MEDIA_AR, POSSESSING_THE_GATES_OF_THE_ENEMY_MEDIA_EN, PROPHECY_MEDIA_AR, PROPHECY_MEDIA_EN, THE_JOURNEY_MEDIA_AR, THE_JOURNEY_MEDIA_EN } from "../product-media-data";
import { BOOK_NAMES_AR, BOOK_NAMES_EN } from "./book-constants";

/*******************
 * DISCERNMENT OF SPIRITS BOOK
 ******************/
const DISCERNMENT_OF_SPIRITS_BOOK_META_DATA = {
	id: 1,
  	type: ProductType.BOOK,
	price: 160,
	originalPrice: 160,
	discount: 0,
	category: BookCategory.SPIRITUAL_GROWTH,
	publishedDate: "2025-10-15",
	pages: 180,
	language: Language.AR,
	originalLanguage: Language.EN,
	bookFormat: BookFormat.PHYSICAL,
	inStock: true,
	stockQuantity: 45,
	rating: 4.8,
	reviewsCount: 2847,
	tags: ["purpose", "spiritual growth", "christian living", "bestseller"],
	featured: true,
	bestseller: true,
	newRelease: false,
	
	dimensions: { height: 23, width: 15, depth: 2 },
	weight: 180,
	createdAt: "2025-10-15",
	updatedAt: "2024-01-20T14:30:00Z"
}
export const DISCERNMENT_OF_SPIRITS_BOOK_EN: Book = {
  
	name: BOOK_NAMES_EN.DISCERNMENT_OF_SPIRITS,
  	author: AUTHOR_NAMES_EN.REBECCA_GREENWOOD,
	description: "Discerning the Spirit Realm: The Key to Powerful Prayer and Victorious Warfare",
    	fullDescription: "Rebecca Greenwood believes that the key to effective warfare prayer is discerning what spiritual forces are at work around you. When you can sense the movement of God’s Spirit and identify the enemy’s tactics, you can pray with power, warring from a position of victory! Prayer leader, prophetic intercessor, and spiritual warfare strategist, Rebecca Greenwood offers this powerful resource for seeing in the spirit realm and victorious warfare prayer.",
	media: DISCERNMENT_OF_SPIRITS_MEDIA_EN,
	publisher: CONTACT_EN.NAME ,
	translators: [TONY_MODY_EN, SARAH_ESSAM_EN],
	tableOfContents: [
		"Acknowledgments",
		"Introduction",
		"Chapter One: Defining Discernment",
		"Chapter Two: They Will Hear My Voice",
		"Chapter Three: Maturity in Hearing and Discernment",
		"Chapter Four: Discernment and Prophecy Working Together",
		"Chapter Five: Learning Discernment Through Observation in Nature",
		"Chapter Six: Discerning Angels",
		"Chapter Seven: Discerning the Demonic Realm",
		"Chapter Eight: Territorial Discernment",
		"Chapter Nine: Discerning Times and Seasons",
		"Chapter Ten: Discerning the Movements of the Holy Spirit",
		"Conclusion: A Prayer to Awaken Discernment in You!",
		"Appendix: List of Manifested Demonic Gatherings"
	],
  	...DISCERNMENT_OF_SPIRITS_BOOK_META_DATA
}
export const DISCERNMENT_OF_SPIRITS_BOOK_AR: Book = {
  
	name: BOOK_NAMES_AR.DISCERNMENT_OF_SPIRITS,
  	author: AUTHOR_NAMES_AR.REBECCA_GREENWOOD,
	description: "تمييز عالم الروح: مفتاح الصلاة القوية والحرب المنتصرة",
    	fullDescription: "تؤمن ريبيكا غرينوود بأن مفتاح الصلاة الحربية الفعالة هو التمييز بين القوى الروحية التي تعمل من حولك. عندما تستطيع أن تشعر بحركة روح الله وتحدد تكتيكات العدو، يمكنك الصلاة بقوة، محاربًا من موقع النصر! تقدم ريبيكا غرينوود، قائدة الصلاة، والمتنبئة، واستراتيجية الحرب الروحية، هذا المورد القوي لرؤية العالم الروحي والصلاة المنتصرة في الحرب.",
	media: DISCERNMENT_OF_SPIRITS_MEDIA_AR,
	publisher: CONTACT_EN.NAME ,
	translators: [TONY_MODY_AR, SARAH_ESSAM_AR],
	tableOfContents: [
		"شكر",
		"مقدمة",
		"الفصل الأول: تعريف التمييز",
		"الفصل الثاني: سوف يسمعون صوتي",
		"الفصل الثالث: النضج في السمع والتمييز",
		"الفصل الرابع: التمييز والنبوة يعملان معًا",
		"الفصل الخامس: تعلم التمييز من خلال الملاحظة في الطبيعة",
		"الفصل السادس: تمييز الملائكة",
		"الفصل السابع: تمييز عالم الشياطين",
		"الفصل الثامن: التمييز الإقليمي",
		"الفصل التاسع: تمييز الأوقات والفصول",
		"الفصل العاشر: تحركات الروح القدس التمييزية",
		"الخاتمة: صلاة لإيقاظ التمييز فيك!",
		"الملحق: قائمة التجمعات الشيطانية الظاهرة"
	],
  	...DISCERNMENT_OF_SPIRITS_BOOK_META_DATA
}
/*******************
 * POSSESSING THE GATES OF THE ENEMY BOOK
 ******************/
const POSSESSING_THE_GATES_OF_ENEMY_BOOK_META_DATA = {
	id: 2,
  	type: ProductType.BOOK,
	price: 200,
	originalPrice: 200,
	discount: 0,
	category: BookCategory.SPIRITUAL_GROWTH,
	publishedDate: "2025-10-15",
	pages: 334,
	language: Language.AR,
	bookFormat: BookFormat.PHYSICAL,
	inStock: true,
	stockQuantity: 45,
	rating: 4.8,
	reviewsCount: 2847,
	tags: ["prayer", "spiritual growth", "christian living", "bestseller"],
	featured: true,
	bestseller: true,
	newRelease: false,
		
	originalLanguage: Language.EN,
	dimensions: { height: 23, width: 15, depth: 2 },
	weight: 180,
	createdAt: "2025-10-15",
	updatedAt: "2024-01-20T14:30:00Z"
}
export const POSSESSING_THE_GATES_OF_ENEMY_BOOK_EN: Book = {
  
	name: BOOK_NAMES_EN.POSSESSING_THE_GATES_OF_THE_ENEMY,
  	author: AUTHOR_NAMES_EN.CINDY_JACOBS,
	description: "Possessing the Gates of the Enemy: A Training Manual for Militant Intercession",
    	fullDescription: "This book is a wealth of information on prayer and intercession. It covers everything from the call to intercede to conducting \"spiritual mapping\" and praying to break strongholds over your city. This book is a definite for intercessors, pastors and other spiritual leaders to understand the depth involved in spiritual warfare.",
	media: POSSESSING_THE_GATES_OF_THE_ENEMY_MEDIA_EN,
	publisher: CONTACT_EN.NAME ,
	translators: [MIRA_MAKRAM_EN],
	tableOfContents: [
		"Foreword",
		"Preface",
		"1. The Call to Intercession",
		"2. Leaders of Intercession",
		"3. The Principle of a Pure Heart",
		"4. Performers of God's Will",
		"5. The Ministry of Intercession",
		"6. The Gift of Intercession",
		"7. Prayer Leaders",
		"8. The Language of Intercession",
		"9. Manifestations of Intercession",
		"10. Balanced Prayer for Others",
		"11. Intercession and Prophecy",
		"12. Prayer Partners",
		"13. Intercessory Praise",
		"14. Corporate Intercession",
		"15. Watchman Prayer and Prayer Marches",
		"16. Possessing the Gates of the Enemy",
		"Study Guide"
	],
  	...POSSESSING_THE_GATES_OF_ENEMY_BOOK_META_DATA
}
export const POSSESSING_THE_GATES_OF_ENEMY_BOOK_AR: Book = {
	name: BOOK_NAMES_AR.POSSESSING_THE_GATES_OF_THE_ENEMY,
  	author: AUTHOR_NAMES_AR.CINDY_JACOBS,
  	"description": "امتلاك أبواب العدو: دليل تدريبي للشفاعة القتالية",
  	"fullDescription": "هذا الكتاب هو كنز من المعلومات حول الصلاة والشفاعة. وهو يغطي كل شيء بدءًا من الدعوة للشفاعة وصولاً إلى إجراء «المسح الروحي» والصلاة لكسر المعاقل والحصون في مدينتك. يُعد هذا الكتاب مرجعاً أساسياً للمشفعين والقساوسة وغيرهم من القادة الروحيين لفهم العمق المطلوب في الحرب الروحية.",
	media: POSSESSING_THE_GATES_OF_THE_ENEMY_MEDIA_AR,
	publisher: CONTACT_EN.NAME ,
	translators: [MIRA_MAKRAM_AR],
	tableOfContents: [
		"تقديم",
		"تمهيد",
		"١. الدعوة للتشفع",
		"٢. قادة التشفع",
		"٣. مبدأ القلب النقي",
		"٤. المنفذون لمشيئة الله",
		"٥. خدمة التشفع",
		"٦. موهبة التشفع",
		"٧. قادة الصلاة",
		"٨. لغة الشفاعة",
		"٩. مظاهر الشفاعة",
		"١٠. الصلاة الغير متوازنة",
		"١١. الشفاعة والنبوة",
		"١٢. شركاء الصلاة",
		"١٣. التسبيح التشفعي",
		"١٤. الشفاعة المشتركة",
		"١٥. صلاة الحراسة ومسيرات الصلاة",
		"١٦. امتلاك أبواب العدو",
		"مرشد دراسي"
	],
  	...POSSESSING_THE_GATES_OF_ENEMY_BOOK_META_DATA
}
/*******************
 * ESSENTIAL GUIDE TO THE PROPHETIC BOOK
 ******************/
const ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_META_DATA = {
	id: 3,
  	type: ProductType.BOOK,
	price: 140,
	originalPrice: 140,
	discount: 0,
	category: BookCategory.SPIRITUAL_GROWTH,
	publishedDate: "2025-10-15",
	pages: 100,
	language: Language.AR,
	bookFormat: BookFormat.PHYSICAL,
	inStock: true,
	stockQuantity: 45,
	rating: 4.8,
	reviewsCount: 2847,
	tags: ["purpose", "spiritual growth", "christian living", "bestseller"],
	featured: true,
	bestseller: true,
	newRelease: false,
	
	originalLanguage: Language.EN,
	dimensions: { height: 23, width: 15, depth: 2 },
	weight: 180,
	createdAt: "2025-10-15",
	updatedAt: "2024-01-20T14:30:00Z"
}
export const ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_EN: Book = {
  
	name: BOOK_NAMES_EN.PROPHECY,
  	author: AUTHOR_NAMES_EN.CINDY_JACOBS,
	description: "Essential Guide to the Prophetic: A Practical Handbook for Understanding and Activating the Prophetic Gift",
    	fullDescription: "This book is a comprehensive resource for anyone seeking a deeper understanding of hearing God's voice in their life. It covers vital topics such as the goals of prophecy, how to distinguish between different types of visions and dreams, and the importance of submitting to spiritual protocol. It is the perfect resource for believers looking to develop their prophetic gifts with a spirit of humility and excellence, providing practical guidance on how to steward these gifts for the building up of the church.",
	media: PROPHECY_MEDIA_EN,
	publisher: CONTACT_EN.NAME ,
	translators: [TONY_MODY_EN],
	tableOfContents: [
		"Introduction",
		"1. The Voice of God",
		"2. What is the Goal of Prophecy?",
		"3. Preparing to Hear the Voice of God",
		"4. Is There a Protocol for Prophecy?",
		"5. Releasing the Prophetic Gift",
		"6. Prophetic Intercession and Callings",
		"7. Dreams and Visions",
		"8. I Need Help! Mentoring the Prophetic Gift",
		"Conclusion"
	],
  	...ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_META_DATA
}
export const ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_AR: Book = {
	name: BOOK_NAMES_AR.PROPHECY,
  	author: AUTHOR_NAMES_AR.CINDY_JACOBS,
	"description": "الدليل الأساسي للنبوة: دليل عملي لفهم وتفعيل الموهبة النبوية",
  	"fullDescription": "هذا الكتاب هو مرجع شامل لكل من يرغب في فهم أعمق لصوت الله في حياته. يغطي الكتاب موضوعات حيوية مثل أهداف النبوة، وكيفية التمييز بين أنواع الرؤى والأحلام، وأهمية الخضوع للبروتوكول الروحي. إنه المورد المثالي للمؤمنين الذين يسعون لتنمية مواهبهم النبوية بروح من الاتضاع والتميز، ويوفر إرشادات عملية حول كيفية توجيه هذه المواهب لبناء الكنيسة.",
  	media: PROPHECY_MEDIA_AR,
	publisher: CONTACT_EN.NAME ,
	translators: [TONY_MODY_AR],
	tableOfContents: [
		"مقدمة",
		"١. صوت الله",
		"٢. ما هو هدف النبوة؟",
		"٣. الاستعداد لسماع صوت الله",
		"٤. هل يوجد بروتوكول للنبوة؟",
		"٥. إطلاق العطية النبوية",
		"٦. الدعوات النبوية والشفاعة النبوية",
		"٧. الأحلام والرؤى",
		"٨. أحتاج إلى مساعدة! توجيه موهبة النبوة",
		"خاتمة"
	],
  	...ESSENTIAL_GUIDE_TO_THE_PROPHETIC_BOOK_META_DATA
}
/*******************
 * LETTERS OF FIRE BOOK
 ******************/
const LETTERS_OF_FIRE_BOOK_META_DATA = {
	id: 4,
  	type: ProductType.BOOK,
	price: 75,
	originalPrice: 75,
	discount: 0,
	category: BookCategory.SPIRITUAL_GROWTH,
	publishedDate: "2025-10-15",
	pages: 110,
	language: Language.AR,
	bookFormat: BookFormat.PHYSICAL,
	inStock: true,
	stockQuantity: 45,
	rating: 4.8,
	reviewsCount: 2847,
	tags: ["purpose", "spiritual growth", "christian living", "bestseller"],
	featured: true,
	bestseller: true,
	newRelease: false,
	originalLanguage: Language.EN,
	dimensions: { height: 23, width: 15, depth: 2 },
	weight: 180,
	createdAt: "2025-10-15",
	updatedAt: "2024-01-20T14:30:00Z"
}
export const LETTERS_OF_FIRE_BOOK_EN: Book = {
  
	name: BOOK_NAMES_EN.LETTERS_OF_FIRE,
  	author: AUTHOR_NAMES_EN.AMAL_SAMUEL,
	"description": "Letters of Fire: A Comprehensive Study on the Gift of Speaking in Tongues",
	"fullDescription": "This book provides a deep theological and practical study of one of the most debated gifts of the Holy Spirit: speaking in tongues. The author reviews biblical evidence and testimonies from the Early Church Fathers to prove the continuity of this gift today. The book also addresses practical aspects such as the benefits of personal tongues, their regulations within the church, and how to overcome spiritual obstacles to receiving this gift, making it an indispensable guide for every believer seeking to experience the fullness of the Holy Spirit.",
	media: LETTERS_OF_FIRE_MEDIA_EN,
	publisher: CONTACT_EN.NAME ,
	tableOfContents: [
		"Word of Thanks",
		"Foreword",
		"What They Said About the Book",
		"Author's Introduction",
		"Chapter One: The Holy Spirit.. The Other Helper",
		"Chapter Two: The Gift of Speaking in Personal Tongues",
		"Chapter Three: Benefits of Speaking in Personal Tongues",
		"Chapter Four: Obstacles to Speaking in Tongues and How to Deal with Them",
		"Chapter Five: The Gift of Speaking in Tongues and the Gift of Interpretation",
		"Chapter Six: Regulations for Speaking in Tongues Within the Church",
		"Chapter Seven: Are There Satanic Tongues?",
		"Chapter Eight: Is it Permissible to Prohibit Tongues in Churches?",
		"Chapter Nine: Did Tongues Cease with the End of the Apostolic Age?",
		"Chapter Ten: Patristic Testimonies Supporting the Gift of Speaking in Tongues",
		"Chapter Eleven: Isaiah's Prophecy and its Relation to the Gift of Speaking in Tongues",
		"Chapter Twelve: Spiritual Rest and Speaking in Tongues",
		"Chapter Thirteen: How to Receive the Gift of Speaking in Tongues?",
		"Conclusion",
		"Appendix: Tests and Testimonies"
	],
  	...LETTERS_OF_FIRE_BOOK_META_DATA
}
export const LETTERS_OF_FIRE_BOOK_AR: Book = {
	name: BOOK_NAMES_AR.LETTERS_OF_FIRE,
  	author: AUTHOR_NAMES_AR.AMAL_SAMUEL,
	"description": "حروف من نار: دراسة شاملة حول عطية التكلم بالألسنة",
  	"fullDescription": "يقدم هذا الكتاب دراسة لاهوتية وعملية عميقة حول واحدة من أكثر مواهب الروح القدس جدلاً: التكلم بالألسنة. يستعرض الكاتب الأدلة الكتابية وشهادات آباء الكنيسة الأوائل ليثبت استمرارية هذه الموهبة اليوم. كما يتناول الكتاب الجوانب العملية مثل فوائد الألسنة الشخصية، ضوابطها داخل الكنيسة، وكيفية التغلب على المعوقات الروحية لاستقبال هذه العطية، مما يجعله دليلاً لا غنى عنه لكل مؤمن يسعى لاختبار ملء الروح القدس.",
  	media: LETTERS_OF_FIRE_MEDIA_AR,
	publisher: CONTACT_EN.NAME ,
	tableOfContents: [
		"كلمة شكر",
		"تقديم",
		"قالوا عن الكتاب",
		"مقدمة الكاتب",
		"الفصل الأول: الروح القدس.. المعزي الآخر",
		"الفصل الثاني: عطية (هبة) التكلم بالألسنة الشخصية",
		"الفصل الثالث: فوائد التكلم بالألسنة الشخصية",
		"الفصل الرابع: معوقات التكلم بالألسنة والتعامل معها",
		"الفصل الخامس: موهبة التكلم بالألسنة وموهبة ترجمتها",
		"الفصل السادس: ضوابط التكلم بالألسنة داخل الكنيسة",
		"الفصل السابع: هل توجد ألسنة شيطانية؟",
		"الفصل الثامن: هل يجوز منع الألسنة في الكنائس؟",
		"الفصل التاسع: هل بطلت الألسنة بانتهاء عصر الرسل؟",
		"الفصل العاشر: شهادات آبائية تؤيد موهبة التكلم بالألسنة",
		"الفصل الحادي عشر: نبوة إشعياء وعلاقتها بموهبة التكلم بالألسنة",
		"الفصل الثاني عشر: الراحة الروحية والتكلم بالألسنة",
		"الفصل الثالث عشر: كيف تستقبل عطية الصلاة بالألسنة؟",
		"الختام",
		"الملحق: اختبارات وشهادات"
	],
  	...LETTERS_OF_FIRE_BOOK_META_DATA
}
/*******************
 * THE JOURNEY BOOK
 ******************/
const THE_JOURNEY_BOOK_META_DATA = {
	id: 5,
  	type: ProductType.BOOK,
	price: 50,
	originalPrice: 50,
	discount: 0,
	category: BookCategory.SPIRITUAL_GROWTH,
	publishedDate: "2025-10-15",
	pages: 48,
	language: Language.AR,
	bookFormat: BookFormat.PHYSICAL,
	inStock: true,
	stockQuantity: 45,
	rating: 4.8,
	reviewsCount: 2847,
	tags: ["purpose", "spiritual growth", "christian living", "bestseller"],
	featured: true,
	bestseller: true,
	newRelease: false,
	originalLanguage: Language.EN,
	dimensions: { height: 23, width: 15, depth: 2 },
	weight: 180,
	createdAt: "2025-10-15",
	updatedAt: "2024-01-20T14:30:00Z"
}
export const THE_JOURNEY_BOOK_EN: Book = {
  
	name: BOOK_NAMES_EN.THE_JOURNEY,
  	author: AUTHOR_NAMES_EN.DINA_KHALED,
	 "description": "Spiritual Journey: Exploring the Gates of Grace and Salvation",
  	"fullDescription": "This spiritual guide takes the reader on a journey through the fundamental concepts of the Christian walk. From understanding the personification of Grace to navigating the legal and spiritual dimensions of the Court of Heaven, this book offers profound insights into spiritual gates and the power of living prayers. It concludes by centering the believer's focus on the ultimate truth: that Jesus Christ is the source of all life.",
	media: THE_JOURNEY_MEDIA_EN,
	publisher: CONTACT_EN.NAME ,
	tableOfContents: [
		"Chapter One: Lady Grace",
		"Chapter Two: The City of Salvation",
		"Chapter Three: The Court of Heaven",
		"Chapter Four: Spiritual Gates",
		"Chapter Five: Living Prayers",
		"Chapter Six: Jesus is the Life"
	],
  	...THE_JOURNEY_BOOK_META_DATA
}
export const THE_JOURNEY_BOOK_AR: Book = {
	name: BOOK_NAMES_AR.THE_JOURNEY,
  	author: AUTHOR_NAMES_AR.DINA_KHALED,
	 "description": "رحلة روحية: استكشاف أبواب النعمة والخلاص",
  	"fullDescription": "يأخذ هذا الدليل الروحي القارئ في رحلة عبر المفاهيم الأساسية للمسيرة المسيحية. من فهم تجسيد النعمة إلى التنقل في الأبعاد القانونية والروحية لمحكمة السماء، يقدم هذا الكتاب رؤى عميقة حول الأبواب الروحية وقوة الصلوات الحية. ويختتم الكتاب بتركيز انتباه المؤمن على الحقيقة الأسمى: أن يسوع المسيح هو مصدر كل حياة." ,
	media: THE_JOURNEY_MEDIA_AR,
	publisher: CONTACT_EN.NAME ,
	tableOfContents: [
		"الفصل الأول: السيدة نعمه",
		"الفصل الثاني: مدينة الخلاص",
		"الفصل الثالث: محكمة السماء",
		"الفصل الرابع: أبواب روحية",
		"الفصل الخامس: صلوات حية",
		"الفصل السادس: يسوع هو الحياة"
	],
  	...THE_JOURNEY_BOOK_META_DATA
}
/*******************
 * FACE TO FACE BOOK
 * ******************/
const FACE_TO_FACE_BOOK_META_DATA = {
	id: 6,
  	type: ProductType.BOOK,
	price: 75,
	originalPrice: 75,
	discount: 0,
	category: BookCategory.SPIRITUAL_GROWTH,
	publishedDate: "2025-10-15",
	pages: 70,
	language: Language.AR,
	bookFormat: BookFormat.PHYSICAL,
	inStock: true,
	stockQuantity: 45,
	rating: 4.8,
	reviewsCount: 2847,
	tags: ["purpose", "spiritual growth", "christian living", "bestseller"],
	featured: true,
	bestseller: true,
	newRelease: false,
	originalLanguage: Language.EN,
	dimensions: { height: 23, width: 15, depth: 2 },
	weight: 180,
	createdAt: "2025-10-15",
	updatedAt: "2024-01-20T14:30:00Z"
}
export const FACE_TO_FACE_BOOK_EN: Book = {
  
	name: BOOK_NAMES_EN.FACE_TO_FACE,
  	author: AUTHOR_NAMES_EN.MARIAN_MAZOZA,
	 "description": "Spiritual Journey: Exploring the Gates of Grace and Salvation",
  	"fullDescription": "This spiritual guide takes the reader on a journey through the fundamental concepts of the Christian walk. From understanding the personification of Grace to navigating the legal and spiritual dimensions of the Court of Heaven, this book offers profound insights into spiritual gates and the power of living prayers. It concludes by centering the believer's focus on the ultimate truth: that Jesus Christ is the source of all life.",
	media: FACE_TO_FACE_MEDIA_EN,
	publisher: CONTACT_EN.NAME ,
	tableOfContents: [
		"Introduction",
		"1. An Authoritative Word",
		"2. Do Not Touch the Shroud.. I Do Not Want to Be Exposed",
		"3. Who Sinned?",
		"4. You Are Not My Father",
		"5. You Will Never Be a Disgrace",
		"6. Cut the Secret Cord",
		"7. I Will Not Let You Go Unless You Bless Me",
		"8. You Are the Reason",
		"9. There Are No Accusers",
		"10. Heal My Words",
		"11. I Did Not Receive Compensation",
		"12. Speak",
		"13. Who Are You?",
		"14. A Whale Swallowed Me",
		"15. Untie the Knots",
		"16. Sing, O Deborah",
		"17. Build a Network",
		"18. You Are a Peg in the Hand of Heaven",
		"19. Walk One More Mile with Me So I Can Heal You, Says the Lord",
		"20. You Will Not Be Ashamed Anymore",
		"21. You Are a Coal of Fire",
		"22. Half a Heart",
		"23. A Day Without a Heart-Sting",
		"24. You Will No Longer Be Like a Stone",
		"25. Attack, Do Not Defend",
		"26. Be a Samaritan on the Way",
		"27. Were It Not for the Hardships, You Wouldn't Have Become Fire",
		"28. With Good Wine Until the End",
		"29. Complete Healing",
		"30. We Are Behind You (We've Got Your Back)",
		"Conclusion"
	],
  	...FACE_TO_FACE_BOOK_META_DATA
}
export const FACE_TO_FACE_BOOK_AR: Book = {
	name: BOOK_NAMES_AR.FACE_TO_FACE,
  	author: AUTHOR_NAMES_AR.MARIAN_MAZOZA,  
	"description": "وَجْهاً إِلَى وَجْهٍ: رحلة للشفاء الداخلي والترميم",
 	"fullDescription": "كتاب «وَجْهاً إِلَى وَجْهٍ» هو دليل قوي يركز على الترميم النفسي والتحرر من قيود الماضي. يتناول الكتاب قضايا عميقة مثل الخزي، وجروح الأبوة، وعقلية «الضحية»، مستخدماً رموزاً كتابية—مثل قصص يونان ودبورة—لتمكين القارئ. إنها دعوة للانتقال من حالة الانكسار والصمت إلى حياة السلطان والشفاء التام والنار الروحية، مع تذكير كل مؤمن بأنه مسنود من الله ومن الجماعة المؤمنة.",
	media: FACE_TO_FACE_MEDIA_AR,
	publisher: CONTACT_EN.NAME ,
	tableOfContents: [
		"مقدمة",
		"١. كلمة علم لها سلطان",
		"٢. لا تلمس الكفن.. لا أريد أن أتعرى",
		"٣. من أخطأ؟",
		"٤. أنت لست أبي",
		"٥. أبداً لم تكوني عار",
		"٦. اقطعي الحبل السري",
		"٧. لن أطلقك أن لم تباركني",
		"٨. أنتي السبب",
		"٩. لا يوجد مشتكون",
		"١٠. اشفي كلماتي",
		"١١. لم اخذ تعويض",
		"١٢. تكلمي",
		"١٣. من أنتي؟",
		"١٤. ابتلعنى حوت",
		"١٥. فكي العقد",
		"١٦. أنشدي يادبورة",
		"١٧. أصنعي شباكاً",
		"١٨. أنتي وتد بيد السماء",
		"١٩. ميلاً آخر سيري معي لأشفيكي قال لي الرب",
		"٢٠. لن تخجلي فيما بعد",
		"٢١. أنتي جمرة نار",
		"٢٢. نصف قلب",
		"٢٣. يوم بدون وخز قلب",
		"٢٤. لن تكوني كحجر بعد",
		"٢٥. هاجمي ولا تدافعي",
		"٢٦. كوني سامري في الطريق",
		"٢٧. لولا الصعوبات لما صرتي نار",
		"٢٨. بخمر جيدة حتى النهاية",
		"٢٩. شفاء تاماً",
		"٣٠. احنا في ضهرك",
		"الخاتمة"
	],
  	...FACE_TO_FACE_BOOK_META_DATA
}